import { render } from "./ConfigEditor.vue?vue&type=template&id=0e82504a"
import script from "./ConfigEditor.vue?vue&type=script&lang=js"
export * from "./ConfigEditor.vue?vue&type=script&lang=js"
script.render = render

export default script